import { CONST } from "../CONST";
import ProgressiveLoadChunk from "../components/ProgressiveLoadChunk";

export class ProgressiveLoadScene extends Phaser.Scene{

    private loadQueue: ProgressiveLoadChunk[] = [];
    private loadedChunks: ProgressiveLoadChunk[] = [];
    private currChunk ?: ProgressiveLoadChunk;

    constructor(){
        super({
            key: CONST.SCENES.PROGRESSIVE_LOAD,
        })
    }

    //Load 
    init(){
        this.registry.set(CONST.SCENES.PROGRESSIVE_LOAD, this);
        
        this.loadQueue = [
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.BIRTH],
                imagesKey: CONST.BIRTH,
                audio: [CONST.AUDIO.CRY] 
            }),
             new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.TALK],
                imagesKey: CONST.TALK,
                audio: [CONST.AUDIO.TALK, CONST.AUDIO.POP]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.SOUNDTRACK],
                audio: [CONST.AUDIO.SOUNDTRACK],
                loadedCallback: () => {
                    this.registry.get(CONST.SCENES.SOUNDTRACK).switchMusic();
                }
            }),           
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.SCHOOL],
                imagesKey: CONST.SCHOOL,
                animations: [CONST.ANIMATIONS.SCHOOLEND],
                audio: [CONST.AUDIO.GRAB]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.PUBERTY],
                imagesKey: CONST.PUBERTY,
                animations: [CONST.ANIMATIONS.PUBERTYEND],
                audio: [CONST.AUDIO.POP]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.FINDHER],
                imagesKey: CONST.FINDHER,
                animations: [CONST.ANIMATIONS.FINDHEREND]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.BEERPONG],
                imagesKey: CONST.BEERPONG,
                physics: [CONST.PHYSICS.BEERPONG]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.COFFEE],
                imagesKey: CONST.COFFEE,
                animations: [CONST.ANIMATIONS.COFFEEEND],
                audio: [CONST.AUDIO.GRAB]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.MARRIAGE],
                imagesKey: CONST.MARRIAGE,
                animations: [CONST.ANIMATIONS.MARRIAGEWIN, CONST.ANIMATIONS.MARRIAGEFROWN],
                audio: [CONST.AUDIO.GRAB, CONST.AUDIO.BOUNCE]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.KIDS],
                imagesKey: CONST.KIDS,
                animations: [CONST.ANIMATIONS.KIDSSHOOTBABY, CONST.ANIMATIONS.DADHEAD],
                audio: [CONST.AUDIO.CRY]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.MIDLIFE, CONST.SCENES.GRANDCHILDREN],
                imagesKey: CONST.MIDLIFE,
                animations: [CONST.ANIMATIONS.MIDLIFELEFTFOOT, CONST.ANIMATIONS.MIDLIFERIGHTFOOT, CONST.ANIMATIONS.MIDLIFEWIN]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.GRANDCHILDREN],
                imagesKey: CONST.GRANDCHILDREN,
                animations: [CONST.ANIMATIONS.GRANDPAMOVE, CONST.ANIMATIONS.GRANDPALEFTHAND, CONST.ANIMATIONS.GRANDPARIGHTHAND, CONST.ANIMATIONS.KIDTORSO, CONST.ANIMATIONS.KIDRIGHTLEG, CONST.ANIMATIONS.KIDLEFTLEG, CONST.ANIMATIONS.KIDDIEELECTRIC, CONST.ANIMATIONS.KIDDIEFIRE],
                audio: [CONST.AUDIO.NOOO]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.PILLS],
                imagesKey: CONST.PILLS,
                animations: [CONST.ANIMATIONS.PILLSEND],
                physics: [CONST.PHYSICS.PILLS]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.DIE],
                imagesKey: CONST.DIE,
                audio: [CONST.AUDIO.DIESONG, CONST.AUDIO.LIGHTNING]
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.CREDITS],
                imagesKey: CONST.CREDITS
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.INSTRUMENT],
                imagesKey: CONST.INSTRUMENT,
                audio: [CONST.AUDIO.INSTRUMENT_1,
                       CONST.AUDIO.INSTRUMENT_2,
                       CONST.AUDIO.INSTRUMENT_3,
                       CONST.AUDIO.INSTRUMENT_4,
                       CONST.AUDIO.INSTRUMENT_5,
                       CONST.AUDIO.INSTRUMENT_6,
                       CONST.AUDIO.INSTRUMENT_7,
                       CONST.AUDIO.INSTRUMENT_FAIL,
                       CONST.AUDIO.WIN,
                       CONST.AUDIO.LOSE],
               tag: [CONST.TAGS.ARCADE, CONST.SCENES.INSTRUMENT],
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.BURGER],
                imagesKey: CONST.BURGER,
                audio: [CONST.AUDIO.GRAB, CONST.AUDIO.WIN, CONST.AUDIO.LOSE, CONST.AUDIO.TRASH],
                tag: [CONST.TAGS.ARCADE, CONST.SCENES.BURGER],
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.DISTRACTION],
                imagesKey: CONST.DISTRACTION,
                audio: [CONST.AUDIO.HELLO,
                    CONST.AUDIO.PING_1,
                    CONST.AUDIO.PING_2,
                    CONST.AUDIO.LOSE,
                    CONST.AUDIO.TV_OFF,
                    CONST.AUDIO.TV_ON,
                    CONST.AUDIO.VIBRATE,
                    CONST.AUDIO.BOUNCE,
                    CONST.AUDIO.POP,
                    CONST.AUDIO.LOSE],
                tag: [CONST.TAGS.ARCADE, CONST.SCENES.DISTRACTION],
            }),
            new ProgressiveLoadChunk(this, {
                requiredFor: [CONST.SCENES.GRID_FILL],
                imagesKey: CONST.GRID_FILL,
                audio: [CONST.AUDIO.FLASH, CONST.AUDIO.WIN, CONST.AUDIO.LOSE],
                tag: [CONST.TAGS.ARCADE, CONST.SCENES.GRID_FILL],
            }),
        ];
    }

    preload(){
        this.load.on('filecomplete', (key: string, file: any) =>{
            //console.log("File complete: " + key);
            if (!this.currChunk) return;
            this.currChunk.handleFileComplete(key);
        }, this);
    }

    update(){
        this.loadNextChunkNew();
    }

    private loadNextChunkNew(){
        //return if all chunks are loaded
        if (this.loadQueue.length == 0 && !this.currChunk) return;

        //Start loading next chunk if nothing is loading at the moment
        if (!this.currChunk){
            //console.log("loading next chunk");
            this.currChunk = this.loadQueue.shift();
            return;
        }

        //Start loading current chunk if no chunk is loading already
        if (!this.currChunk.isLoaded() && !this.currChunk.isLoading()){
            this.currChunk.Load();
            this.load.start();
        }

        //Add current chunk to loaded chunks after it is loaded
        if (this.currChunk.isLoaded()){
            this.loadedChunks.push(this.currChunk);
            this.currChunk = undefined;
        }
    }

    public prioritizeChunksWithTag(tag: string){
        // console.log("Prioritizing chunks with tag: " + tag);

        var tagChunks = this.loadQueue.filter(chunk => chunk.hasTag(tag));
        var otherChunks = this.loadQueue.filter(chunk => !chunk.hasTag(tag));

        this.loadQueue = [...tagChunks, ...otherChunks];
    }

    isSceneLoaded(sceneName: string){
        if (this.currChunk && this.currChunk.isBlockingScene(sceneName)){
            return false;
        }

        for(let chunk of this.loadQueue){
            if (chunk.isBlockingScene(sceneName)){
                return false;
            }
        }
        return true;
    }
}